import { Environment } from '@environments/interface.environment';
import { RouteConfig } from '@app/common/route-config';
import { DefaultProtectedResourceScopesMap } from '@app/common/msal-angular-configuration';

// RISE Prod
// https://risepdp.azurewebsites.net/

export const environment: Environment = {
  production: true,
  name: 'risepdp',
  title: 'RISE PDP',
  tenant: 'https://risecloud.sharepoint.com',
  routeConfig: RouteConfig.routes,
  msalConfig: {
    tenant: 'risecloud.onmicrosoft.com',
    auth: {
      clientId: '24981169-6415-4a7a-b598-594a7261bc8a',
      authority: 'https://login.microsoftonline.com/risecloud.onmicrosoft.com',
    },
    protectedResourceScopeMap: [
      ...DefaultProtectedResourceScopesMap,
      [`/api/`, [`24981169-6415-4a7a-b598-594a7261bc8a/.default`]],
      ['https://risecloud.sharepoint.com', ['https://risecloud.sharepoint.com/.default']],
    ],
    useRedirect:true,
  },
  appInsightsTrackingKey: '2abe6563-decf-4430-ac23-4e6c9fa5bd04',
  gaTrackingKey: '',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

